import { assertExists, groupArrayBy } from '@/utils/general'

const mergeAltCurrency = (price, filteredArray) => {
  return filteredArray.map(obj => {
    /* istanbul ignore else */
    if (!price.currency_alt || price.currency_alt.total === 0) return obj

    const alt = price.currency_alt.components.find(ex => ex.object_id === obj.object_id)
    return { ...obj, currency_alt: alt }
  })
}

export default {
  computed: {
    getMandatoryExtrasPriceZero() {
      /* istanbul ignore else */
      if (!this.price.components) return false

      const filtered = this.price.components.filter(
        component =>
          component.extra_fields !== null &&
          component.object_type !== 'person' &&
          component.extra_fields.is_mandatory &&
          component.price === 0
      )

      const mapped = mergeAltCurrency(this.price, filtered)
      return mapped.length > 0 ? mapped : false
    },
    getMandatoryExtrasPriceNotZeroGrouped() {
      if (!this.price.components) return false
      const filtered = this.price.components.filter(
        component =>
          component.extra_fields !== null &&
          component.object_type !== 'person' &&
          component.extra_fields.is_mandatory &&
          component.price !== 0
      )
        const grouped = Object.values(
          filtered.reduce((acc, item) => {
            const key = `${item.code}-${item.name}`

            if (!acc[key]) {
              acc[key] = { ...item, price: 0 }
            }

            acc[key].price += item.price
            return acc
          }, {})
        )
        const mapped = mergeAltCurrency(this.price, grouped)
        return mapped.length > 0 ? mapped : false
    },
    getMandatoryExtrasPriceNotZero() {
      /* istanbul ignore else */
      if (!this.price.components) return false
      const filtered = this.price.components.filter(
        component =>
          component.extra_fields !== null &&
          component.object_type !== 'person' &&
          component.extra_fields.is_mandatory &&
          component.price !== 0
      )
      const mapped = mergeAltCurrency(this.price, filtered)
      return mapped.length > 0 ? mapped : false
    },

    getGuestBySeason() {
      /* istanbul ignore else */
      if (!this.price.components) return false

      const filteredPersons = this.price.components.filter(
        component => component.extra_fields === null && component.object_type === 'person'
      )
      return filteredPersons.length > 0 ? groupArrayBy(filteredPersons, 'season_name') : false
    },

    getUserExtras() {
      /* istanbul ignore else */
      if (!this.price.components) return false

      const filtered = this.price.components.filter(
        component =>
          component.extra_fields !== null &&
          component.object_type !== 'person' &&
          !component.extra_fields.is_mandatory
      )

      return filtered.length > 0 ? filtered : false
    },

    getUserCampsites() {
      /* istanbul ignore else */
      if (!this.price.components) return false
      const filteredCampsites = this.price.components.filter(
        component => component.object_type === 'campsite'
      )
      return filteredCampsites.length > 0 ? groupArrayBy(filteredCampsites, 'season_name') : false
    },
  },
  mounted() {
    /** test if variables used in this mixin exist in the context the component **/
    assertExists('price', this)
  },
}
